import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'
// Runtime config is now loaded via hook; no provider needed
import { loadRuntime } from './lib/api'
import './index.css'
import './styles/status.css'

if (typeof globalThis !== 'undefined') {
  const pin = (import.meta.env.VITE_SAFETY_CONFIRM_PIN ?? '').trim()
  globalThis.__SAFETY_CONFIRM_PIN__ = pin
  globalThis.__IMPORT_META_ENV__ = { ...(import.meta.env || {}), VITE_SAFETY_CONFIRM_PIN: pin }
}

if (import.meta.env.DEV && 'PerformanceObserver' in window) {
  try{
    const po = new PerformanceObserver((list)=> {
      const shifts = list.getEntries().filter(e=> !e.hadRecentInput && e.value>0);
      if (shifts.length) console.warn('[CLS]', shifts.map(e=>e.value));
    });
    po.observe({type:'layout-shift', buffered:true});
  } catch {
    // Layout-shift diagnostics are optional in browsers without full observer support.
  }
}

async function boot() {
  await loadRuntime();
  if (navigator.serviceWorker?.getRegistrations) {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      for (const registration of registrations) await registration.unregister();
    } catch {
      // A stale service worker must not prevent the dashboard from booting.
    }
  }

  ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </React.StrictMode>,
  )
}
boot()
